export default __webpack_public_path__ + "static/media/ret-res2.6f1a5a6e.jpg";